import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import { SPACING_16 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import List from 'components/List';

export interface FileUploadListProps extends React.ComponentPropsWithRef<'div'> {
  /** The content of the `FileUploadList`. */
  children?: React.ReactNode;
  /** To override the theme. Please refer to the List documentation for theme override. */
  theme?: any;
  /** @ignore */
  style?: any;
}

/**
 * Simple wrapper of List. Provide basic style for list of files in FileUpload.
 * It uses a wrapper of the CCFK List component.
 * All props rather than `children` will be provided to the List component.
 * To get the ref of the outermost element use `ref` prop. [Read React useRef hook documentation](https://reactjs.org/docs/hooks-reference.)
 */
const FileUploadList = React.forwardRef<HTMLElement, FileUploadListProps>((props: FileUploadListProps, ref) => {
  const {
    children,
    theme: themeProp,
    style,
    ...otherProps
  } = props;
  const listTheme = getContext(({ theme }) => theme.LIST.VERTICAL);
  const resolvedTheme = _merge({}, listTheme, themeProp);
  return (
    <List
      ref={ref}
      style={{
        padding: 0,
        marginBottom: SPACING_16,
        borderLeft: `0.0625rem solid ${resolvedTheme.divider as string}`,
        borderRight: `0.0625rem solid ${resolvedTheme.divider as string}`,
        background: 'transparent',
        minHeight: 0,
        ...style
      }}
      hoverEffect
      truncateListText
      elevationProps={{
        elevationIndex: 0,
        dark: false
      }}
      {...otherProps}
    >
      {children}
    </List>
  );
});

FileUploadList.displayName = 'FileUploadList';
FileUploadList.defaultProps = {
  children: undefined,
  theme: {},
  style: {}
};

export default FileUploadList;
